import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const useSearchSystem = (products, mixedProductsArr, comProductsArr) => {
  const navigate = useNavigate();
  const splitPath = window.location.pathname.split("/");
  const term = splitPath[splitPath.length - 1];
  // console.log(splitPath)
  const [searchTerm, setSearchTerm] = useState(
    splitPath[1] === "search" ? term : ""
  );
  const [searchParams, setSearchParams] = useSearchParams()
  const [filteredProducts, setFilteredProducts] = useState(null);
  const [filters, setFilters] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [includeCom, setIncludeCom] = useState(false);
  const [displayedProductsType, setDisplayedProductsType] = useState("store");

  const changeTerm = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const search = (e) => {
    e.preventDefault();

    if(searchTerm) {
      const searchTermToNavigate = searchTerm?.replace(" ", "-");
      const newProds = products?.filter(
        (prod) =>
          prod.title.toLowerCase().includes(searchTerm?.toLowerCase()) ||
          prod.category.toLowerCase().includes(searchTerm?.toLowerCase())
      );
      // console.log(newProds)
  
      setFilteredProducts(newProds);
      navigate(`/search/${searchTermToNavigate.toLowerCase()}`);
    }
  };

  useEffect(() => {
    if (splitPath[1] === "search" && term !== searchTerm) {
      setSearchTerm(term.replace("-", " "));
      console.log(`changed searchTerm to ${searchTerm}`);
    }
    let newProducts = null;

    if (displayedProductsType === "com-only") {
      newProducts = comProductsArr?.filter(
        (prod) =>
          prod.title
            .toLowerCase()
            .includes(term?.replace("-", " ").toLowerCase()) ||
          prod.category
            .toLowerCase()
            .includes(term?.toLowerCase())
      );
        // setSearchParams({filter: "/only-com"})
    } else if (displayedProductsType === "mix") {
      newProducts = mixedProductsArr?.filter(
        (prod) =>
          prod.title
            .toLowerCase()
            .includes(term?.replace("-", " ").toLowerCase()) ||
          prod.category
            .toLowerCase()
            .includes(term?.toLowerCase())
      );
      // setSearchParams({filter: "/mix"})
    } else {
      newProducts = products?.filter(
        (prod) =>
          prod.title
            .toLowerCase()
            .includes(term?.replace("-", " ").toLowerCase()) ||
          prod.category
            .toLowerCase()
            .includes(term?.toLowerCase())
      );
    }

    // console.log("term is:", term.toLowerCase())
    // newProducts = products?.filter(
    //   (prod) =>
    //     prod.title
    //       .toLowerCase()
    //       .includes(term?.replace("-", " ").toLowerCase()) ||
    //     prod.category
    //       .toLowerCase()
    //       .includes(term?.toLowerCase())
    // );

    if (sortBy === "price-up") {
      newProducts?.sort((a, b) => a.price - b.price);
    } else if (sortBy === "price-down") {
      newProducts?.sort((a, b) => b.price - a.price);
    } else if (sortBy === "most-popular") {
      newProducts?.sort((a, b) => b.rating - a.rating);
    } else if (sortBy === "number-reviews") {
      newProducts?.sort(
        (a, b) => Math.round(b.discountedPrice) - Math.round(a.discountedPrice)
      );
    }
    // console.log(newProducts)
    console.log("no infinite loop");
    setFilteredProducts(newProducts);
  }, [term, products, sortBy, includeCom, displayedProductsType]);

  // const filterSearch = (e, selectedPrice, selectedRating, selectedBrand) => {
  //   e.preventDefault();
  //   let tempFilteredProducts = [...filteredProducts];
  //   const toFilter = tempFilteredProducts.length ? tempFilteredProducts : filteredProducts;

  //   if (selectedPrice) {
  //     console.log("the list is", toFilter)

  //     const productsToPush = toFilter?.filter((item) =>
  //       eval(selectedPrice[0]?.replace(/V/g, item.price).replace("/", "&&"))
  //     );
  //     tempFilteredProducts = [...productsToPush];
  //     // console.log("price", toFilter)
  //   }  if (selectedRating) {
  //     console.log("the list is", toFilter)
  //     const productsToPush = toFilter
  //       ?.map((item) => {
  //         return { ...item, rating: Math.round(item.rating) };
  //       })
  //       .filter((item) => selectedRating.includes((item.rating).toString()));
  //     tempFilteredProducts = [...productsToPush];

  //   }  if (selectedBrand) {
  //     console.log("the list is", toFilter)

  //     const productsToPush = toFilter?.filter((item) =>
  //       selectedBrand.includes(item.brand)
  //     );
  //     tempFilteredProducts = [...productsToPush];

  //   }
  //   // else {
  //   //   console.log("no filters")
  //   // };

  //   console.log(tempFilteredProducts);
  // };

  // const filterSearch = (e, selectedPrice, selectedRating, selectedBrand) => {
  //   e.preventDefault();
  //   setFilters([
  //     ...selectedPrice,
  //     ...selectedBrand,
  //     ...selectedRating,
  //   ]);
  //   let tempFilteredProducts = [...filteredProducts];

  //   if (filters.length > 0) {
  //     if (selectedPrice) {
  //       tempFilteredProducts = tempFilteredProducts.filter((item) =>
  //         eval(selectedPrice[0]?.replace(/V/g, item.price).replace("/", "&&"))
  //       );
  //     }

  //     if (selectedRating) {
  //       tempFilteredProducts = tempFilteredProducts
  //         .map((item) => ({ ...item, rating: Math.round(item.rating) }))
  //         .filter((item) => selectedRating.includes(item.rating.toString()));
  //     }

  //     if (selectedBrand) {
  //       tempFilteredProducts = tempFilteredProducts.filter((item) =>
  //         selectedBrand.includes(item.brand)
  //       );
  //     }
  //   }
  //   setFilteredProducts(tempFilteredProducts);
  //   console.log(filters);
  // };

  const filterSearch = (e, selectedPrice, selectedRating, selectedBrand) => {
    e.preventDefault();
    console.log(selectedPrice);
    console.log(selectedRating);
    console.log(selectedBrand);
  };

  const clearFilters = () => {
    setFilters([]);
  };

  return {
    searchTerm,
    search,
    changeTerm,
    filteredProducts,
    setSearchTerm,
    filterSearch,
    filters,
    clearFilters,
    setSortBy,
    setDisplayedProductsType,
    setIncludeCom,
    setSearchParams,
  };
};

export default useSearchSystem;
